const pickupOrProNumbersString = (array) => {
  const numbers = ` #${array.splice(0, 2).join(" #")}`;
  const moreNumbers = array.length ? `+${array.length} more ` : "";
  return `${numbers} ${moreNumbers}`;
};

export { pickupOrProNumbersString };
